import createVueApp from '@/common/create_app'
import sidebar from '@/config/sidebars/jensen'

Styxie.Initializers.JensenPhoneNumberPools = {
  index: async(props) => {
    const { default: PoolsIndex } = await import('@/vue_widgets/jensen/phone_number_pools/index.vue')
    createVueApp(PoolsIndex, { props, sidebar })
  },

  new: async(props) => {
    const { default: PoolsNew } = await import('@/vue_widgets/jensen/phone_number_pools/new.vue')
    createVueApp(PoolsNew, { props, sidebar })
  },

  edit: async(props) => {
    const { default: PoolsEdit } = await import('@/vue_widgets/jensen/phone_number_pools/edit.vue')
    createVueApp(PoolsEdit, { props, sidebar })
  }
}
